module.exports = __webpack_public_path__ + "components/flag/static/square/sg-d822019db45bb4c69c506ac43e9c4ba9.svg";